// extracted by mini-css-extract-plugin
export default {"container":"SuperadminToolsContainer_container__YI0+T","header":"SuperadminToolsContainer_header__UnVZC"};